import { memo } from 'react';
import goblinDown      from './goblin-melee/goblin-melee-down.png';
import goblinUp        from './goblin-melee/goblin-melee-up.png';
import goblinLeftDown  from './goblin-melee/goblin-melee-leftdown.png';
import goblinRightDown from './goblin-melee/goblin-melee-rightdown.png';

const DIR_MAP = {
  up:    goblinUp,
  down:  goblinDown,
  left:  goblinLeftDown,
  right: goblinRightDown,
};

/**
 * Directional goblin-melee PNG sprite.
 *
 * All four directional images are always present in the SVG so the browser
 * fetches them all on first mount. Direction changes only toggle visibility —
 * no href mutation, no extra network requests.
 *
 * Props:
 *   dir  — 'up' | 'down' | 'left' | 'right'  (pre-computed by EnemyLayer)
 *   size — width & height in px
 */
export const GoblinMeleeSprite = memo(function GoblinMeleeSprite({ dir, size }) {
  return (
    <img
      src={DIR_MAP[dir] ?? DIR_MAP.down}
      width={size}
      height={size}
      style={{ display: 'block', imageRendering: 'pixelated' }}
      alt=""
    />
  );
});
